import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { messageTypes } from '../helpers/MessageTypes';

@Injectable()
export class ObjectNotificationService {
    private subject : BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
    observer$ = this.subject.asObservable();

    sendObject(obj: any){
        this.subject.next(obj);
    }

    clearMessages() {
        this.subject.next([]);
    }

}


// WEBPACK FOOTER //
// ./src/app/service/obj-notification.service.ts